import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useLocation } from "@reach/router"
import { useStaticQuery, graphql } from "gatsby"
import { seoConfig } from "../../utils/seoConfig" // Importamos la configuración personalizada de SEO

const SEO = ({ title, description, slug, image }) => {
  const query = graphql`
    query SEO {
      site {
        siteMetadata {
          defaultTitle: title
          defaultDescription: description
          siteUrl: url
        }
      }
    }
  `

  const { pathname } = useLocation()

  const { site } = useStaticQuery(query)

  const { defaultTitle, defaultDescription, siteUrl } = site.siteMetadata

  // Verificar si hay valores personalizados en seoConfig.js para el slug
  const seoFromConfig = seoConfig[slug] || {}

  // Asegurar que la URL base incluya www
  const baseUrl = siteUrl.replace(/^https?:\/\//, 'https://')

  // Construir la URL canónica limpiando dobles slashes
  const canonicalUrl = `${baseUrl}${pathname}`.replace(/([^:]\/)\/+/g, "$1")

  // Usar los valores de seoConfig si están definidos, o los valores predeterminados del sitio
  const seo = {
    title: title || seoFromConfig.metaTitle || defaultTitle,
    description: description || seoFromConfig.metaDescription || defaultDescription,
    url: canonicalUrl, // Usar la URL canónica limpia
    image: image ? image.gatsbyImageData.src : "", 
  }

  // Agregar console.log para debug
  console.log('SEO Component:', {
    slug,
    seoFromConfig: seoConfig[slug],
    finalTitle: seo.title,
    canonicalUrl,
    baseUrl
  });

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      
      {/* Agregar etiqueta canonical con www */}
      <link rel="canonical" href={canonicalUrl} />

      {seo.url && <meta property="og:url" content={seo.url} />}

      {seo.title && <meta property="og:title" content={seo.title} />}
      {seo.description && <meta property="og:description" content={seo.description} />}
      {seo.image && <meta property="og:image" content={seo.image} />}
      <meta name="twitter:card" content="summary" />
      {seo.title && <meta name="twitter:title" content={seo.title} />}
      {seo.description && <meta name="twitter:description" content={seo.description} />}
    </Helmet>
  )
}

export default SEO

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  slug: PropTypes.string.isRequired, // Asegúrate de que el slug sea una propiedad obligatoria
}

SEO.defaultProps = {
  title: null,
  description: null,
}
